module.exports = __webpack_public_path__ + "assets/182d789a80585dfa513ba1d997795478.svg";